import React from 'react'
import SubjectForm from './SubjectForm'
import {Modal} from 'react-bootstrap'


const SubjectEdit = ({show,handleModalClose,handleSubmit,subject,icons}) => (
  <div>
    <Modal show={show} backdrop="static" keyboard={false} onHide={() => handleModalClose(false)}>
        <Modal.Header closeButton>
            <Modal.Title>Fach bearbeiten</Modal.Title>
        </Modal.Header>
          <SubjectForm
             handleSubmit={handleSubmit} subject={subject} icons={icons}
            />
        </Modal>
  </div>
)

export default SubjectEdit